import { VehicleModelOutputWithStatus } from './vehicle-model-output-with-status.model';


export class VehicleModelSelectByIdOutput implements IVehicleModelSelectByIdOutput {
    status!: number;
    message!: string;
    data!: VehicleModelOutputWithStatus;

    constructor(data?: IVehicleModelSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleModelOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleModelSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleModelSelectByIdOutput {
    status: number;
    message: string;
    data: VehicleModelOutputWithStatus;
}

